import format from './format'

export {
  format
}


// WEBPACK FOOTER //
// core-build-local/filters/date/index.js